module.exports = __webpack_public_path__ + "img/minus.3110d709.svg";